import { Layout } from 'antd';
import { AppFooter, AppHeader, RoutedContent } from '.';
import { usePathInterceptor } from '../lib/axios';
import './auto-eins-app.scss';
import { Banner } from './components/banner';

const { Header, Content, Footer } = Layout;

export const AutoEinsApp: React.FC = () => {
    usePathInterceptor();

    return (
        <Layout>
            <Header>
                <AppHeader />
            </Header>

            <Banner />

            <Content className='app-container'>
                <RoutedContent />
            </Content>

            <Footer>
                <AppFooter />
            </Footer>
        </Layout>
    );
};
